<template>
    <div class="order-list">
      <template v-if="list.length >0">
        <ActivityOrder class="gap-bottom" @click.native="orderDetail(item)" :is-list="true" :order="item" v-for="item in list" :key="item.Id" />
      </template>
      <EmptyData v-else />
    </div>
</template>

<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { activityOrderListAPI } from "@/api/activity";
import { checkResponse } from "@/assets/js/utils";
import ActivityOrder  from './components/ActivityOrder'
import EmptyData from '@/components/EmptyData'
export default {
  name: "ActivityOrderList",
  components: {ActivityOrder,EmptyData},
  data() {
    return {
      list: [],
    };
  },
  mounted() {
      BridgeNativeMethods.setTitle("我的报名");
    this.requestData();
  },
  methods: {
    requestData() {
      console.log("loading")
      BridgeNativeMethods.showLoading();
      activityOrderListAPI().then(
        (response) => {
          BridgeNativeMethods.hideLoading();
          if (checkResponse(response)) {
           this.list = response.data
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          BridgeNativeMethods.hideLoading();
          BridgeNativeMethods.showToast("请求错误");
          console.log(err);
        }
      );
    },
    orderDetail(item) {
        console.log(item)
        this.$router.push({
              name: 'ActivityOrderDetail',
              params:{id:item.Id}
          })
    }
  },
};
</script>

<style lang="less" scoped>
.order-list{
    padding-top: 16px;
}
</style>